import { DEFAULT_CURRENCY } from '../../../../../utils/currency';

export const getInitialForm = () => ({
  attachments: [],
  to: null,
  cc: null,
  bcc: null,
  email: null,
  emailJson: null,
  subject: null,
  subjectJson: null,
  signableOfferTemplate: null,
  signatory: null,
  bonus: null,
  bonusCurrency: DEFAULT_CURRENCY.value,
  candidateName: null,
  companyName: null,
  directManager: null,
  equity: null,
  jobTitle: null,
  offerExpirationDate: null,
  paidTimeOff: null,
  salary: null,
  salaryCurrency: DEFAULT_CURRENCY.value,
  senderName: null,
  sickDays: null,
  startingDate: null,
  todayDate: null,
  workingHours: null,
  customVariables: new Map<string, any>(),
});
